<template>
  <footer class="bg-casino-sidebar border-t border-white/5 py-8 px-6">
    <div class="max-w-7xl mx-auto">
      <!-- Main Footer Content -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
        <!-- Brand Column -->
        <div>
          <div class="flex items-center gap-2 mb-4">
            <img src="/todofino_icon.png" alt="TodoFino" class="w-8 h-8 rounded-lg object-cover" />
              <img src="/todofino_logo.png" alt="TodoFino.bet" class="h-7" />
          </div>
          <p class="text-sm text-gray-400 mb-4">
            {{ t('footer.tagline') }}
          </p>
          <!-- OCULTO: redes sociales sin links reales configurados
          <div class="flex items-center gap-3">
            <a href="#" class="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors">
              <span class="text-sm">𝕏</span>
            </a>
            <a href="#" class="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors">
              <span class="text-sm">in</span>
            </a>
            <a href="#" class="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors">
              <span class="text-sm">📘</span>
            </a>
            <a href="#" class="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors">
              <span class="text-sm">📸</span>
            </a>
          </div>
          -->
        </div>

        <!-- Games Column -->
        <div>
          <h4 class="text-sm font-semibold text-white mb-4 uppercase tracking-wider">{{ t('footer.games') }}</h4>
          <ul class="space-y-2">
            <li>
                <RouterLink to="/games?category=slot" class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                  {{ t('sidebar.slots') }}
                </RouterLink>
            </li>
            <li>
              <RouterLink to="/games?category=table" class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                {{ t('sidebar.tableGames') }}
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/games?category=live" class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                {{ t('sidebar.liveCasino') }}
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/games?category=featured" class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                {{ t('footer.featuredGames') }}
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/favorites" class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                {{ t('footer.myFavorites') }}
              </RouterLink>
            </li>
          </ul>
        </div>

        <!-- OCULTO: enlaces de Soporte sin handler. Centro de Ayuda y Chat en Vivo no funcionan.
        <div>
          <h4 class="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Soporte</h4>
          <ul class="space-y-2">
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Centro de Ayuda
              </button>
            </li>
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Chat en Vivo
              </button>
            </li>
            <li>
              <RouterLink to="/history" class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Historial de Juegos
              </RouterLink>
            </li>
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Juego Responsable
              </button>
            </li>
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Auto-Exclusión
              </button>
            </li>
          </ul>
        </div>
        -->

        <!-- OCULTO: enlaces legales sin handler. No llevan a ninguna pagina real.
        <div>
          <h4 class="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Legal</h4>
          <ul class="space-y-2">
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Términos de Servicio
              </button>
            </li>
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Política de Privacidad
              </button>
            </li>
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Política de Cookies
              </button>
            </li>
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Política AML
              </button>
            </li>
            <li>
              <button class="text-sm text-gray-400 hover:text-casino-primary-light transition-colors">
                Verificación KYC
              </button>
            </li>
          </ul>
        </div>
        -->
      </div>

      <!-- OCULTO: metodos de pago hardcodeados, no reflejan los reales del operador.
      <div class="border-t border-white/5 pt-6 mb-6">
        <p class="text-xs text-gray-500 mb-3 uppercase tracking-wider">Métodos de Pago Aceptados</p>
        <div class="flex items-center gap-3 flex-wrap">
          <div class="px-3 py-1.5 bg-white/5 rounded text-xs text-gray-400 border border-white/5">💳 Visa</div>
          <div class="px-3 py-1.5 bg-white/5 rounded text-xs text-gray-400 border border-white/5">💳 Mastercard</div>
          <div class="px-3 py-1.5 bg-white/5 rounded text-xs text-gray-400 border border-white/5">₿ Bitcoin</div>
          <div class="px-3 py-1.5 bg-white/5 rounded text-xs text-gray-400 border border-white/5">Ξ Ethereum</div>
          <div class="px-3 py-1.5 bg-white/5 rounded text-xs text-gray-400 border border-white/5">🅿️ PayPal</div>
          <div class="px-3 py-1.5 bg-white/5 rounded text-xs text-gray-400 border border-white/5">💰 Skrill</div>
          <div class="px-3 py-1.5 bg-white/5 rounded text-xs text-gray-400 border border-white/5">🏦 Transferencia Bancaria</div>
        </div>
      </div>
      -->

      <!-- OCULTO: certificaciones y licencias falsas, no verificables.
      <div class="border-t border-white/5 pt-6 mb-6">
        <div class="flex flex-wrap items-center justify-between gap-4">
          <div class="flex items-center gap-4">
            <div class="flex items-center gap-2 text-xs text-gray-500">
              <ShieldCheck class="w-4 h-4 text-casino-win" />
              <span>SSL Seguro</span>
            </div>
            <div class="flex items-center gap-2 text-xs text-gray-500">
              <span class="text-casino-win">🔒</span>
              <span>Encriptación 256-bit</span>
            </div>
            <div class="flex items-center gap-2 text-xs text-gray-500">
              <span class="text-casino-win">✓</span>
              <span>RNG Certificado</span>
            </div>
          </div>
          <div class="flex items-center gap-2 text-xs text-gray-500">
            <span>Licenciado por:</span>
            <span class="text-gray-400">Curacao eGaming</span>
          </div>
        </div>
      </div>
      -->

      <!-- Bottom Bar -->
      <div class="border-t border-white/5 pt-6">
        <div class="flex flex-col md:flex-row items-center justify-between gap-4">
          <p class="text-xs text-gray-500">
            {{ t('footer.copyright') }}
          </p>
          <div class="flex items-center gap-4 text-xs text-gray-500">
            <span class="flex items-center gap-1">
              <span class="text-lg">🔞</span>
              {{ t('footer.adultsOnly') }}
            </span>
            <span class="flex items-center gap-1">
              <span class="text-casino-loss">⚠️</span>
              {{ t('footer.addictive') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
// ShieldCheck ya no se usa: certificaciones comentadas
</script>
